import moment from 'moment';
import { MARIAFILO, FOXTON } from './brands';

const MARIA_FILO_AND_FOXTON_NEW_RANGE = moment('2026-03-01');
const MF_COMP_02_START = moment('2026-01-26');
const MF_COMP_02_END = moment('2026-02-28');

export default (date, brandId) => {
    if ([MARIAFILO, FOXTON].includes(Number(brandId))) {
        // A partir de 01/03/2026: primeiro dia ao último dia do mês
        if (moment().isSameOrAfter(MARIA_FILO_AND_FOXTON_NEW_RANGE, 'day')) {
            return {
                startDate: moment(date).startOf('month'),
                endDate: moment(date).endOf('month'),
            };
        }

        // Fevereiro/2026: período especial 26/jan - 28/fev
        const dateMoment = moment(date);
        if (dateMoment.year() === 2026 && dateMoment.month() === 1) {
            return {
                startDate: MF_COMP_02_START.clone(),
                endDate: MF_COMP_02_END.clone(),
            };
        }

        // Antes de fevereiro/2026: regra padrão 26/mês anterior - 25/mês
        const day = moment(date).startOf('month');
        return {
            startDate: day
                .clone()
                .subtract(1, 'month')
                .date(26),
            endDate: day.clone().date(25),
        };
    }

    if (Number(brandId) === 16) {
        if (
            date.isBefore(
                moment()
                    .hour(0)
                    .date(1)
                    .month(7)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date).startOf('month'),
                endDate: moment(date).endOf('month'),
            };
        }
        if (
            date.isSameOrBefore(
                moment()
                    .hour(0)
                    .date(1)
                    .month(8)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date).startOf('month'),
                endDate: moment(date).date(25),
            };
        }
        if (
            date.isAfter(
                moment()
                    .hour(0)
                    .date(1)
                    .month(8)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date)
                    .subtract(1, 'month')
                    .date(26),
                endDate: moment(date).date(25),
            };
        }
    } else {
        if (
            date.isBefore(
                moment()
                    .hour(0)
                    .date(1)
                    .month(4)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date).startOf('month'),
                endDate: moment(date).endOf('month'),
            };
        }
        if (
            date.isSameOrBefore(
                moment()
                    .hour(0)
                    .date(1)
                    .month(5)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date).startOf('month'),
                endDate: moment(date).date(25),
            };
        }
        if (
            date.isAfter(
                moment()
                    .hour(0)
                    .date(1)
                    .month(5)
                    .year(2021)
            )
        ) {
            return {
                startDate: moment(date)
                    .subtract(1, 'month')
                    .date(26),
                endDate: moment(date).date(25),
            };
        }
    }
};
